import React, { useEffect } from 'react';
import FileTabs from '../../components/FileTabs/FileTabs';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { checkIsLoaded, checkIsLoading } from '../../lib/utils/checkLoadingStatus';
import {
  getMaritalStatusDictionary,
  getRegionDictionary,
  getSubwayStationDictionary,
} from '../../store/slices/dictionariesSlice/dictionariesSlice';
import {
  cleanPersonCard,
  cleanPersonFullCard,
  getPersonCard,
  getPersonFullCard,
} from '../../store/slices/personsSlice/personsSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { Spin, Row, Modal, message } from 'antd';
import { getProjects } from '../../store/slices/projectsSlice/projectsSlice';
import { ReactComponent as BackArrow } from '../../lib/img/back-arrow.svg';
import { hasAccess } from '../../lib/utils/usePermissions';
import { PERSON_READ_FULLACCESS } from '../../lib/const/permissions';

function FileMainContainer() {
  const { fileId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { maritalStatusLoading, regionLoading, subwayStationLoading } = useAppSelector((state) => state.dictionaries);
  const { personFullCard, personFullCardLoading, personCard, personCardLoading } = useAppSelector(
    (state) => state.persons
  );
  const { projectsLoading } = useAppSelector((state) => state.projects);

  useEffect(() => {
    return () => {
      dispatch(cleanPersonCard());
      dispatch(cleanPersonFullCard());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!checkIsLoaded(maritalStatusLoading)) dispatch(getMaritalStatusDictionary());
    if (!checkIsLoaded(regionLoading)) dispatch(getRegionDictionary());
    if (!checkIsLoaded(subwayStationLoading)) dispatch(getSubwayStationDictionary());
    if (!checkIsLoaded(projectsLoading)) dispatch(getProjects({}));
  }, [dispatch]);

  const isMinAccess = !hasAccess([PERSON_READ_FULLACCESS]);
  const personLoading = isMinAccess ? personCardLoading : personFullCardLoading;
  const personData = isMinAccess ? personCard : personFullCard;

  const getFullAccessPersonCard = async () => {
    const resultAction = await dispatch(getPersonFullCard({ id: Number(fileId) }));

    // Изза того что Thank не отдавал ответ в catch, сделал проверку через сам Thank
    if (getPersonFullCard.rejected.match(resultAction) && resultAction.payload?.status === 403) {
      Modal.error({
        content: resultAction.payload?.message,
        className: 'font-roboto password-forgotten-info-modal',
        width: '550px',
        icon: false,
        bodyStyle: {
          backgroundColor: '#F4F4F4',
          paddingTop: '20px',
          marginTop: '111px',
        },
        onOk: () => {
          message.destroy();
          Modal.destroyAll();
          navigate('/applications/list');
        },
      });
    }

    if (getPersonFullCard.rejected.match(resultAction) && resultAction.payload?.status !== 403) {
      message.destroy();
      message.error(
        {
          content: 'Ошибка загрузки анкеты: ' + resultAction.payload?.message || '',
        },
        3
      );
    }
  };

  const getMinAccessPersonCard = async () => {
    const resultAction = await dispatch(getPersonCard({ id: Number(fileId), searchParams: { fields: ['PHONES'] } }));

    // Изза того что Thank не отдавал ответ в catch, сделал проверку через сам Thank
    if (getPersonCard.rejected.match(resultAction) && resultAction.payload?.status === 403) {
      Modal.error({
        content: resultAction.payload?.message,
        className: 'font-roboto password-forgotten-info-modal',
        width: '550px',
        icon: false,
        bodyStyle: {
          backgroundColor: '#F4F4F4',
          paddingTop: '20px',
          marginTop: '111px',
        },
        onOk: () => {
          message.destroy();
          Modal.destroyAll();
          navigate('/applications/list');
        },
      });
    }

    if (getPersonCard.rejected.match(resultAction) && resultAction.payload?.status !== 403) {
      message.destroy();
      message.error(
        {
          content: 'Ошибка загрузки анкеты: ' + resultAction.payload?.message,
        },
        3
      );
    }
  };

  useEffect(() => {
    if (fileId) {
      // Ограниченный доступ для просмотра (телефона,фио,фото)
      if (isMinAccess) {
        getMinAccessPersonCard();
      } else {
        // Полный доступ
        getFullAccessPersonCard();
      }
    }
  }, [dispatch]);

  const shouldRender = () =>
    personData && checkIsLoaded(maritalStatusLoading, regionLoading, subwayStationLoading, projectsLoading);

  const getFio = () => {
    return `${personData?.lastName} ${personData?.firstName} ${personData?.middleName ? personData?.middleName : ''}`;
  };

  const isVisiblePerson = personFullCard?.lastName || personFullCard?.firstName || personFullCard?.middleName;

  return (
    <Spin
      className="container_height"
      spinning={checkIsLoading(
        personLoading,
        projectsLoading,
        maritalStatusLoading,
        regionLoading,
        subwayStationLoading
      )}
    >
      {shouldRender() && (
        <>
          <div className="pl20 pr20">
            <Row>
              {isVisiblePerson && <BackArrow className="ml6 mt8 mr10 cursor-pointer" onClick={() => navigate('..')} />}
              <h2
                className="fullName"
                style={{
                  textDecoration: 'underline',
                  textDecorationColor: '#7590A3',
                  textUnderlineOffset: '7px',
                }}
              >
                {getFio()}
              </h2>
            </Row>
            <FileTabs />
          </div>
          <Outlet />
        </>
      )}
    </Spin>
  );
}

export default FileMainContainer;
